import { useTemplateComponents } from "components/Resume/templateUtils";
import { BaseForm } from "components/ResumeForm/Form";
import {
  Input,
  InputPhoto,
  Textarea,
} from "components/ResumeForm/Form/InputGroup";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import {
  changeProfile,
  changeProfileStatus,
  selectProfile,
  selectResume,
} from "lib/redux/resumeSlice";
import { selectSettings } from "lib/redux/settingsSlice";
import { ResumeProfile } from "lib/redux/types";
import { selectUserProfilePhoto, setUserProfilePhoto } from "lib/redux/uiSlice";
import Image from "next/image";
import { useEffect, useState } from "react";

export const ProfileForm = () => {
  const profile = useAppSelector(selectProfile);
  const dispatch = useAppDispatch();
  const { name, email, phone, url1, url2, summary, location } = profile;
  const resume = useAppSelector(selectResume);
  const settings = useAppSelector(selectSettings);
  const profilePic = useAppSelector(selectUserProfilePhoto);
  const { templateList, template } = useTemplateComponents(resume, settings);
  const isImageTemplateSelected = templateList.find(
    (t) => t.id === template
  )?.hasImage;

  const handleProfileChange = (field: keyof ResumeProfile, value: string) => {
    dispatch(changeProfile({ field, value }));
  };
  useEffect(() => {}, [resume.profileStatus]);

  const removePhoto = () => {
    dispatch(changeProfileStatus("DELETED"));
    dispatch(setUserProfilePhoto(null));
    localStorage.removeItem("profile-photo");
  };

  return (
    <BaseForm>
      <div className="grid grid-cols-6 gap-3">
        <Input
          label="Name"
          labelClassName="col-span-full"
          name="name"
          placeholder="Alex Maverick"
          value={name}
          onChange={handleProfileChange}
        />
        <Textarea
          label="Summary"
          labelClassName="col-span-full"
          name="summary"
          placeholder="Crafting digital experiences with a sprinkle of creativity."
          value={summary}
          onChange={handleProfileChange}
        />
        <Input
          label="Email"
          labelClassName="col-span-4"
          name="email"
          placeholder="alex@creativemind.io"
          value={email}
          onChange={handleProfileChange}
        />
        <Input
          label="Phone"
          labelClassName="col-span-2"
          name="phone"
          placeholder="(123)456-7890"
          value={phone}
          onChange={handleProfileChange}
        />
        <Input
          label="Website 1"
          labelClassName="col-span-4"
          name="url1"
          placeholder="https://linkedin.com/in/maverick"
          value={url1}
          onChange={handleProfileChange}
        />
        <Input
          label="Website 2"
          labelClassName="col-span-4"
          name="url2"
          placeholder="https://github.com/in/maverick"
          value={url2}
          onChange={handleProfileChange}
        />
        <Input
          label="Location"
          labelClassName="col-span-2"
          name="location"
          placeholder="Delhi, India"
          value={location}
          onChange={handleProfileChange}
        />
        {isImageTemplateSelected && (
          <>
            <InputPhoto
              labelClassName="col-span-2"
              name="location"
              label="Upload Photo"
              placeholder="Upload your photo"
              onChange={handleProfileChange}
            />
            {profilePic && (
              <div className="col-span-full flex flex-col gap-3">
                <Image
                  src={profilePic}
                  alt="Profile Picture"
                  width={100}
                  height={100}
                />
                <button
                  type="button"
                  className="w-fit rounded-md border-2 border-red-500 p-2 text-sm text-red-500 underline"
                  onClick={removePhoto}
                >
                  Remove Photo
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </BaseForm>
  );
};
